module.exports = __webpack_public_path__ + "static/media/logo-html5.0263f883.svg";